exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/vtrackOneqlik/oneqlik_wetrack/src/app/vehicle-expenses/vehicle-expense-detail/vehicle-expense-detail.component.scss
// module id = ../../../../../src/app/vehicle-expenses/vehicle-expense-detail/vehicle-expense-detail.component.scss
// module chunks = main